import script from "./JaContentFrame.vue?vue&type=script&setup=true&lang=js"
export * from "./JaContentFrame.vue?vue&type=script&setup=true&lang=js"

import "./JaContentFrame.vue?vue&type=style&index=0&id=f8d78fda&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f8d78fda"]])

export default __exports__